var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7557 13.3969C12.3264 12.4999 11.6521 11.7427 10.8107 11.2126C9.96937 10.6825 8.99522 10.4012 8.00078 10.4012C7.00635 10.4012 6.03219 10.6825 5.19082 11.2126C4.34945 11.7427 3.67519 12.4999 3.2459 13.3969M10.4008 6.08078C10.4008 7.40626 9.32626 8.48078 8.00078 8.48078C6.6753 8.48078 5.60078 7.40626 5.60078 6.08078C5.60078 4.7553 6.6753 3.68078 8.00078 3.68078C9.32626 3.68078 10.4008 4.7553 10.4008 6.08078ZM15.2008 8.00078C15.2008 11.9772 11.9772 15.2008 8.00078 15.2008C4.02433 15.2008 0.800781 11.9772 0.800781 8.00078C0.800781 4.02433 4.02433 0.800781 8.00078 0.800781C11.9772 0.800781 15.2008 4.02433 15.2008 8.00078Z",
    stroke: "#5856D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.04971140.svg";
export { ForwardRef as ReactComponent };